import React from "react";
import { Box, Grid } from "@mui/material";
import {
  InfoOutlined,
  StorageOutlined,
  DirectionsCarFilledOutlined,
  AccessTime,
} from "@mui/icons-material";

import { useVehicleDetailContext } from "contexts/VehicleDetailContext"; // Context for vehicle details
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import { localizeDateTimeShort } from "utils/dateFormats";
const VehicleBasicDetail = () => {
  const { vehicleDetail, loadingVehicle } = useVehicleDetailContext();

  return !loadingVehicle ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <DirectionsCarFilledOutlined color="primary" />}
            title="Vehicle ID"
            subtitle={vehicleDetail?.vehicle_id || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <DirectionsCarFilledOutlined color="primary" />}
            title="Vehicle Type"
            subtitle={vehicleDetail?.vehicleType?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Registration Number"
            subtitle={vehicleDetail?.registration_number || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <StorageOutlined color="primary" />}
            title="Capacity"
            subtitle={`${vehicleDetail?.capacity || 0} ${
              vehicleDetail?.unit || ""
            }`}
          />
        </Grid>

        {vehicleDetail?.last_maintenance_date && (
          <Grid item xs={3}>
            <InformationTile
              icon={() => <AccessTime color="primary" />}
              title="Maintenance Due Date"
              subtitle={localizeDateTimeShort(
                vehicleDetail?.maintenance_due_date
              )}
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Ownership Type"
            subtitle={vehicleDetail?.ownership_type?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Operational Status"
          >
            <Status isActive={vehicleDetail?.status} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default VehicleBasicDetail;
